import PageLoading from "components/base/PageLoading";
import { useAuthUsers } from "pages/Auth/hooks";
import React, { Suspense } from "react";
import { useLogin } from "./hooks";
import Login from "./Login";

const LoginContainer = () => {
  const { login, loading: loggingIn, loginWithExistUser } = useLogin();

  const { data: users, loading: usersLoading } = useAuthUsers({
    suspense: true,
  });

  return (
    <Login
      onLogin={login}
      onLoginWithExistUser={loginWithExistUser}
      loading={loggingIn}
      usersLoading={usersLoading}
      users={users}
    />
  );
};

export default () => (
  <Suspense fallback={<PageLoading loading={true} />}>
    <LoginContainer />
  </Suspense>
);
